import styles from "../styles/components/Detail.module.scss";
import chevron_right from "../assets/icons/chevron_right_black.svg";
import { useEffect, useState } from "react";
export default function Detail({...props}){
    const { children, onClose } = props

    const [state, setstate] = useState("open");

    useEffect(()=>{
        if(state === "closed"){
            setTimeout(function(){onClose()}, 600)
        }
    }, [state])

    const closeDetail = (target:any) => {
        if(target.id === "bg"){
            setstate("closed")
        }
    }

    return (
        <div id="bg" className={styles.background} onClick={(e)=>{closeDetail(e.target)}}>
            <div className={`${styles.detail} ${state === "closed" && styles.close_detail}`}>
                <button onClick={()=>{setstate("closed")}} className={styles.close_button}><img src={chevron_right} alt="icon"/></button>
                {children}
            </div>
        </div>
    )
}